export const insumosRoutes = [
  {
    path: '/insumos',
    name: 'Insumos',
    component: () =>
      import(
        /* webpackChunkName: "farmacia" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiNeedle',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Insumos',
      requiresSession: true,
      perfiles: ['FARMACIA'],
      permiso: []
    },
    children: [
      {
        path: '/insumos/solicitudes',
        name: 'SolicitudesInsumosIndex',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Solicitudes/SolicitudesInsumosIndex.vue'
          ),
        icon: 'mdiFileSign',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Solicitudes Insumos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/insumos/lotes',
        name: 'LotesInsumosIndex',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Lotes/LotesInsumosIndex.vue'
          ),
        icon: 'mdiPackageVariant',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Lotes Insumos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      },
      {
        path: '/insumos/lotes/:id',
        name: 'LotesInsumosView',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Lotes/LotesInsumosView.vue'
          ),
        icon: 'mdiPackageVariant',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Lote Insumo',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA']
        }
      },
      {
        path: '/insumos/inventario',
        name: 'InventarioInsumosIndex',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Inventario/InventarioInsumosIndex.vue'
          ),
        icon: 'mdiNeedle',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Inventario Insumos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      },
      {
        path: '/insumos/inventario/:id',
        name: 'InventarioInsumosView',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Inventario/InventarioInsumosView.vue'
          ),
        icon: 'mdiPillMultiple',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Inventario de Insumos',
          requiresSession: true,
          perfiles: ['FARMACIA'],
          permiso: []
        }
      },
      {
        path: '/insumos/actas',
        name: 'ActasInsumosIndex',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Actas/ActasInsumosIndex.vue'
          ),
        icon: 'mdiFileDocumentMultipleOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Actas Insumos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      },
      {
        path: '/insumos/considerandos/:key',
        name: 'ConsiderandosInsumosIndex',
        component: () =>
          import(
            /* webpackChunkName: "insumos" */ '@/modules/Insumos/views/Considerandos/ConsiderandosInsumosIndex.vue'
          ),
        icon: 'mdiTagText',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Considerandos Insumos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      }
    ]
  }
]
